// extracted by mini-css-extract-plugin
export default {"container":"styles_container__X7sQ1","stripe":"styles_stripe__y38k9","button":"styles_button__wbuTg","tabs":"styles_tabs__7AFqW"};